import React from "react";
import PropTypes from "prop-types";
import { Router, Route, Switch } from "react-router-dom";

import config from "config";
import Chat from "containers/Chat";
import ErrorBoundary from "components/atoms/errorBoundary";

import ApplicationInsights from "../containers/applicationInsights";
// import "fe-shared/styles/base.scss";

const MainRouter = ({ history }) => (
  <ApplicationInsights
    instrumentationKey={config.applicationInsights.instrumentationKey}
    history={history}
  >
    <Router history={history}>
      <ErrorBoundary>
        <Switch>
          <Route exact path="/webchat/:id" component={Chat} />
        </Switch>
      </ErrorBoundary>
    </Router>
  </ApplicationInsights>
);

MainRouter.propTypes = {
  history: PropTypes.object, // eslint-disable-line
};

export default MainRouter;
